import React from 'react';
import {SelectField, SelectInput} from "react-admin";

const choices = [
    {id: 'CAMPAIGN_STATUS_UNCOMPLETED', name: 'Terminé'},
    {id: 'CAMPAIGN_STATUS_COMPLETED', name: 'Financé'},
    {id: 'CAMPAIGN_STATUS_FORTHCOMING', name: 'À venir'},
    {id: 'CAMPAIGN_STATUS_IN_PROGRESS', name: 'En cours'},
    {id: 'CAMPAIGN_STATUS_DRAFT', name: 'Brouillon'},
];

const SelectCampaignStatusInput = (props) => (
    <SelectInput {...props} source="status" choices={choices}/>
);

const SelectCampaignStatusField = (props) => (
    <SelectField {...props} source="status" choices={choices}/>
);

export {SelectCampaignStatusInput, SelectCampaignStatusField}
